import { FilterCriteria, ValueFilter } from '../../FilterStore'
import { FloatingTooltip } from '../../../Tooltip/FloatingTooltip'
import { useMemo } from 'react'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'

type FilterChipValue = {
  title?: string
  value: ValueFilter[]
  onClose?: () => void
  filterCriteria: FilterCriteria
  isHovered?: boolean
}

export function FilterChipValue({
  onClose,
  value,
  title,
  filterCriteria,
  isHovered,
}: FilterChipValue) {
  const isExclusive = filterCriteria === 'neither'
  const getFormattedValue = () => {
    if (value.length === 1) return value[0]?.label
    return `${value.length} selected`
  }

  const selectedString = useMemo(() => {
    const selected = value.map((v) => v.label)
    if (selected.length < 1) return ''
    return selected.join(', ')
  }, [value])

  return (
    <FloatingTooltip text={selectedString} placement="top">
      <FilterChipContainer $isExclusive={isExclusive} isHovered={isHovered}>
        <span>
          {`${title}: `}
          <b>{getFormattedValue()}</b>
        </span>
        {onClose && (
          <FilterChipCloseButton
            style={{
              color: isExclusive ? '#9C1F2F' : '#087443',
            }}
            onClick={onClose}
          />
        )}
      </FilterChipContainer>
    </FloatingTooltip>
  )
}
